module.exports = __webpack_public_path__ + "static/img/kcjj.41814f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kcjj.jpg
// module id = S3xp
// module chunks = 1